import { useState, useEffect } from "react";
import Select from "react-select";
import { logo_color } from "../pngs";
import { getImg, privStatePicked, privGtmKey, states } from "../utils";
import {
  sendTag,
  event_properties_100_04,
  event_properties_100_05,
} from "../components/CoalitionGtm";
import "./StatePicker.scss";

export const StatePicker = ({ registerState }) => {
  const gtm = localStorage.getItem(privGtmKey);
  useEffect(() => {
    if (gtm) sendTag(gtm, event_properties_100_04());
  }, [gtm]);

  const handleOnboarding = () => {
    const stateAsString = JSON.stringify(state);
    localStorage.setItem(privStatePicked, stateAsString);
    if (gtm) sendTag(gtm, event_properties_100_05());
    registerState();
  };

  const [state, setState] = useState();
  const isDisabled = !state ? true : false;
  const title = "Personaliza tus beneficios";
  const desc = "Elige el estado de la República en el que te encuentras";
  const selectLabel = "Estado de la República";

  return (
    <div className="state-picker-page">
      <div className="logo">{getImg(logo_color)}</div>
      <div className="title">{title}</div>
      <div className="description">{desc}</div>
      <Select
        className="state-picker"
        isDisabled={false}
        isLoading={false}
        isClearable={false}
        isRtl={false}
        isSearchable={false}
        name={"state"}
        options={states}
        value={state}
        onChange={setState}
        placeholder={selectLabel}
      />
      <button
        className={`control ${isDisabled ? "locked" : ""}`}
        disabled={isDisabled}
        onClick={handleOnboarding}
      >
        Continuar
      </button>
    </div>
  );
};
